var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a_icon-chat{fill:#F4F9FF;}.ba_icon-chat{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a_icon-chat",
    d: "M19,37A18,18,0,0,1,1,19V2.2A1.2,1.2,0,0,1,2.2,1H19a18,18,0,0,1,0,36Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba_icon-chat",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(15.6 15.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba_icon-chat",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(22.8 15.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba_icon-chat",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(8.4 15.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.ec3924e2ebe39352b194b996506068d0.svg";
export { ForwardRef as ReactComponent };